export default __webpack_public_path__ + "static/media/image.f5cc0096.svg";